import React from "react";
import LendingPartnerHeroSection from "./LendingPartnerHeroSection";
import LendingPartnerSection from "./LendingPartnerSection";
import LendingPartnerFormSection from "./LendingPartnerFormSection";

const LendingPartnerPage = () => {
    return (
        <>
            <LendingPartnerHeroSection />
            <LendingPartnerSection />
            {/* <LendingPartnerFormSection /> */}
        </>
    );
};

export default LendingPartnerPage;